<template>
  <div id="app">
      <!-- Width: {{ width }},
      Height: {{ height }} -->
    <navlist v-if="width > 1024" style="margin:54px 0 0 0 ;z-index:100;" />
    <mobilenav v-else style="margin:0 ;" />
    <router-view/>
    <footlist v-if="width > 1024" style="margin:0;" />
    <mobilefoot v-else style="margin:0;" />
  </div>
</template>
<script>
import navlist from './components/navlist.vue'
import footlist from './components/footlist.vue'
import mobilenav from './components/mobilenav.vue'
import mobilefoot from './components/mobilefoot.vue'
export default {
  components:{
    navlist,
    footlist,
    mobilenav,
    mobilefoot
  },
  data(){ 
    return{
          width: 0,
          height: 0,
          // windowTop: 0,
      }
    },
  // mounted() {
  //   window.addEventListener("scroll", this.onScroll)
  //   },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.onScroll)
  //   },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // onScroll(e) {
    // this.windowTop = window.top.scrollY /* or: e.target.documentElement.scrollTop */
    // console.log(this.windowTop) 
    // },
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  }
  
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC&display=swap');
#app {
  /* font-family: 'Avenir', Helvetica, Arial,'Noto Sans TC', sans-serif; */
  font-family: 'Noto Sans TC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin:0;
}

/* 
#homeside{
  position:relative;
  text-align: center;
  float: left;
  width: 46px;
  height: 100%;
  margin: 0 100px 0 53px;
}

#logohome{
  position:relative;
  width: 46px;
  height: 100%;
  margin: 50px auto 320px auto;
}
.icon {
  width: 28px;
  height: 28px;
  margin: 10px auto;
  object-fit: contain;
}

.icon:hover{
  cursor: pointer;
}

#nav{
  position:relative;
  float: right;
  width: 586px;
  height: 35px;
  margin: 74px -10px 84px 0;
  overflow: hidden;
}

#nav a {
  margin: 74px 25px;
  padding: 1px;
  width: 68px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.91px;
  color: #7c7a7a;
  text-decoration: none;
}

#nav a.router-link-exact-active {
  width: 68px;
  height: 19px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.91px;
  color: #d0ad76;
  border-bottom: 1px solid #d0ad76;
}

#nav hr{
  margin-left: 25px;
  width: 85px;
  height: 0px;
  border: 1px solid #d0ad76;
  display: inline-block;
  vertical-align: middle;
  
} */

</style>
